// removed by extract-text-webpack-plugin
module.exports = {"filterLabel":"index__filterLabel___1iWOS","filterSelect":"index__filterSelect___33WN-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/ViewFilter/index.less
// module id = 1242
// module chunks = 3